import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-press-kit-custom',
imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './press-kit-custom.html',
  styleUrl: './press-kit-custom.scss',
})
export class PressKitCustom {

}
